import { I18n } from '@calendly/i18n';
// import { Link } from '@calendly/ui/components/link'
// import { ArrowExpandIcon } from '@calendly/ui/components/icons'
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Description } from '../styles';
import { FormContent } from './form_content';
const userAccessContainerCss = "udoq57b";
const UserAccessContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(userAccessContainerCss, props.className)} />;
});
const customDescriptionCss = "c6gf5q6";
const CustomDescription = forwardRef((props, ref) => <Description ref={ref} {...props} className={classNames(customDescriptionCss, props.className)} />);

// const DescriptionLink = styled(Link)`
// `

export const UserAccess = () => <UserAccessContainer>
    <FlexLayout direction="column" gap={16}>
      <TitleText level={2} size="medium">
        {I18n.t('publisher.admin.login.page.user_access.title')}
      </TitleText>
    </FlexLayout>
    <CustomDescription>
      {I18n.t('publisher.admin.login.page.user_access.description')}
    </CustomDescription>
    {/* COMMENTED TEMPORARILY UNTIL PROPER LINK IS PROVIDED */}
    {/* <DescriptionLink
      rel="noopener"
      target="_blank"
      href="https://help.calendly.com/hc/en-us/articles/13053308362135"
      underline={false}
     >
      {I18n.t('publisher.admin.login.page.user_access.link')}
      <ArrowExpandIcon />
     </DescriptionLink> */}
    <FormContent />
  </UserAccessContainer>;

require("./user_access.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./user_access.js");